import React, { useEffect, useState } from 'react';
import { TimelineListItemTitleText } from '../shared/TimelineListItemTitleText';
import { TimelineListItemDateText } from '../shared/TimelineListItemDateText';
import dayjs from 'dayjs';
import { TimelineListItemInfoChip } from '../shared/TimelineListItemInfoChip';
import '@fontsource/lato';
import { ArrowForward } from '@mui/icons-material';
export const FollowUpTimelineListItem = (props) => {
    const { timelineActivity } = props;
    const [textValue, setTextValue] = useState('');
    const [labelValue, setLabelValue] = useState('');
    useEffect(() => {
        // added if no previous state
        if (timelineActivity.previousState === null && timelineActivity.newState !== null) {
            setTextValue(dayjs(timelineActivity.newState).format('MM/DD/YYYY'));
            setLabelValue('Added');
        }
        // changed if both states
        if (timelineActivity.previousState !== null && timelineActivity.newState !== null) {
            setTextValue(React.createElement(React.Fragment, null,
                dayjs(timelineActivity.previousState).format('MM/DD/YYYY'),
                React.createElement(ArrowForward, { style: { fontSize: '18px', marginTop: 'auto', marginBottom: 'auto', marginLeft: '4px', marginRight: '4px' } }),
                dayjs(timelineActivity.newState).format('MM/DD/YYYY')));
            setLabelValue('Changed');
        }
        if (timelineActivity.previousState !== null && timelineActivity.newState === 'null') {
            setTextValue(dayjs(timelineActivity.previousState).format('MM/DD/YYYY'));
            setLabelValue('Cleared');
        }
    });
    return (React.createElement("div", { className: 'rounded bg-white pl-4 pt-4 pr-4 pb-4 space-y-2 block justify-start m-4' },
        React.createElement(TimelineListItemTitleText, { titleText: timelineActivity.activityTitle }),
        React.createElement(TimelineListItemDateText, { nameText: timelineActivity.userName, dateText: dayjs(timelineActivity.date).format('MM/DD/YYYY HH:mm A') }),
        React.createElement("div", null,
            React.createElement(TimelineListItemInfoChip, { label: labelValue, value: textValue, backgroundColor: '#F5F5F5', textColor: '#757575', showPhoneIcon: false, crossOut: false }))));
};
